import { ApiRequestError } from "@cfg/api-contract";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useApp } from "../app-context.tsx";

/** Pick or change the public display name. Calls `onDone` once the API accepted it. */
export function DisplayNameForm({ initial = "", onDone, autoFocus }: { initial?: string; onDone?: () => void; autoFocus?: boolean }) {
  const { api, copy } = useApp();
  const qc = useQueryClient();
  const [value, setValue] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const save = async () => {
    if (!api) return;
    // Enter on a too-short name says why instead of doing nothing.
    if (value.trim().length < 3) return setError(copy("profile.invalid"));
    setBusy(true);
    setError(null);
    try {
      await api.setProfile({ displayName: value.trim() });
      await qc.invalidateQueries({ queryKey: ["me"] });
      onDone?.();
    } catch (err) {
      setError(err instanceof ApiRequestError && err.body?.code === "invalid_body" ? copy("profile.invalid") : (err as Error).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <form
      className="display-name-form"
      onSubmit={(e) => {
        e.preventDefault();
        void save();
      }}
    >
      <p className="muted small">{copy("profile.prompt")}</p>
      <div className="panel-save-row">
        <input className="cfg-input" autoFocus={autoFocus} aria-label={copy("profile.displayName")} placeholder={copy("profile.displayName")} value={value} maxLength={30} onChange={(e) => setValue(e.target.value)} />
        <button type="submit" className="cfg-btn" disabled={busy}>
          {copy("profile.save")}
        </button>
      </div>
      {error && <p className="cfg-error">{error}</p>}
    </form>
  );
}
